// extracted by mini-css-extract-plugin
export default {"container":"styles_container__5ReCh","button":"styles_button__bRWg6","title":"styles_title__HnY9h"};